import { render, staticRenderFns } from "./AmiiEsIA.vue?vue&type=template&id=0c4b9ce0"
import script from "./AmiiEsIA.vue?vue&type=script&lang=js"
export * from "./AmiiEsIA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports